import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-left-container',
  templateUrl: './left-container.component.html',
  styleUrls: ['./left-container.component.scss']
})
export class LeftContainerComponent implements OnInit {
  isResult: boolean;
  
  constructor() {
    this.isResult = false; 
  }

  ngOnInit(): void {

  }

  
}